import React from 'react';

import { IIconProps, TIconType } from '../interface';

const SearchIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='search'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...props ? { fill: 'currentColor' } : {}}
			/>
			<path
				d='M16.4438 16.4437L21.0001 21'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default SearchIcon;
